// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React from 'react';
import ProgressStep from '../ProgressStep';
/**
 * @deprecated Component `ProgressDialogStep` is deprecated, use `ProgressStep` instead.
 * @since 1.2.0
 */

var ProgressDialogStep = function ProgressDialogStep(props) {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn('Component ProgressDialogStep is deprecated, use ProgressStep instead.');
  }

  return React.createElement(ProgressStep, props);
};

export default ProgressDialogStep;